import { FC } from 'react';

import ApplicationSidebar, {
  APPLICATION_SIDEBAR_ITEMS_IDS
} from 'components/Applications/ApplicationSidebar/ApplicationSidebar';
import AttachmentsView from 'components/AttachmentsView/AttachmentsView';
import FeedbackView from 'components/FeedbackView/FeedbackView';
import ApplicationsFilters from 'components/Filters/ApplicationsFilters';
import JobsFilters from 'components/Filters/JobsFilters';
import JobseekersFilters from 'components/Filters/JobseekersFilters';
import JobDetailsPanel from 'components/JobDetailsPanel/JobDetailsPanel';
import JobShortPreview from 'components/JobShortPreview';
import NotificationsSidebar from 'components/Notifications/components/NotificationsSidebar/NotificationsSidebar';
import ClosedHiresView from 'components/Reports/RecruitmentOverviewReport/ClosedHiresView/ClosedHiresView';

import { AttachmentsOwnerEntities, SidebarContentTypes } from 'constants/enums';

// @ts-ignore
const componentMapping: Record<SidebarContentTypes, FC | React.ReactElement> = {
  [SidebarContentTypes.PreviewJobs]: JobShortPreview,
  [SidebarContentTypes.JobsFilters]: JobsFilters,
  // TODO: remove this after moving to split view
  [SidebarContentTypes.ClientJobView]: () => <JobDetailsPanel openItemId={1} />,
  [SidebarContentTypes.JobseekersFilters]: JobseekersFilters,
  [SidebarContentTypes.ApplicationView]: ApplicationSidebar,
  [SidebarContentTypes.ApplicationsFilters]: ApplicationsFilters,
  [SidebarContentTypes.JobseekerAttachmentsView]: () => (
    <AttachmentsView
      attachmentsOwnerEntity={AttachmentsOwnerEntities.Jobseeker}
    />
  ),
  [SidebarContentTypes.ApplicationAttachmentsView]: () => (
    <AttachmentsView
      attachmentsOwnerEntity={AttachmentsOwnerEntities.Application}
    />
  ),
  [SidebarContentTypes.NotificationsView]: NotificationsSidebar,
  [SidebarContentTypes.OfferView]: (
    <ApplicationSidebar openItemId={APPLICATION_SIDEBAR_ITEMS_IDS.OFFER} />
  ),
  [SidebarContentTypes.ClosedHiresView]: ClosedHiresView,
  [SidebarContentTypes.FeedbackView]: FeedbackView,
  [SidebarContentTypes.InterviewView]: (
    <ApplicationSidebar openItemId={APPLICATION_SIDEBAR_ITEMS_IDS.INTERVIEW} />
  )
};

export default componentMapping;
